<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px" @keydown.ctrl.enter="handleSave">
        <v-card>
            <v-card-text class="pa-4 pb-0">
                <v-container class="pa-0" fluid>
                    <v-row dense>

                        <!-- Descrizione -->
                        <v-col cols="12">
                            <v-text-field v-model="localItem.descrizione" label="Descrizione" outlined dense
                                autofocus />
                        </v-col>

                        <!-- Tipologia -->
                        <v-col cols="12" sm="5">
                            <v-select v-model="localItem.tipologia" :items="tipoImportoOptions" label="Tipo Importo"
                                outlined dense hide-details="auto" />
                        </v-col>

                        <!-- Data -->
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="localItem.data" label="Data" outlined dense hide-details="auto"
                                type="date" />
                        </v-col>

                        <!-- Orario -->
                        <v-col cols="12" sm="3">
                            <!--  <v-menu v-model="menuOrario" :close-on-content-click="false" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="localItem.orario" label="Orario" outlined dense
                                        hide-details="auto" clearable readonly v-bind="attrs" v-on="on" />
                                </template>
<v-time-picker v-if="menuOrario" v-model="localItem.orario" full-width format="24hr"
    @click:minute="menuOrario = false" />
</v-menu> -->

                            <v-menu v-model="menuOrario" :close-on-content-click="false" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="localItem.orario" label="Orario" v-bind="attrs" outlined
                                        dense clearable @blur="normalizeTime" hide-details>
                                        <template v-slot:prepend>
                                            <v-icon tabindex="-1" @click="menuOrario = true">
                                                access_time
                                            </v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-time-picker v-if="menuOrario" v-model="localItem.orario" full-width
                                    @click:minute="menuOrario = false" format="24hr" hide-details />
                            </v-menu>
                        </v-col>

                        <!-- Sezione IMPORTI -->
                        <v-col cols="12" class="pb-0 pt-3">
                            <span class="caption text--secondary font-weight-medium" style="letter-spacing:.08em">
                                <v-icon x-small class="mb-1 mr-1">euro</v-icon>IMPORTI
                            </span>
                        </v-col>

                        <!-- Entrate -->
                        <v-col cols="6">
                            <v-text-field v-model.number="localItem.entrata" label="Entrate" outlined dense
                                type="number" hide-details="auto"
                                :rules="[v => v == null || v >= 0 || 'Valore deve essere positivo']">
                                <template v-slot:prepend-inner>
                                    <v-icon small class="mt-1 mr-1" color="success">trending_up</v-icon>
                                </template>
                                <template v-slot:append>
                                    <span class="caption text--secondary mt-1">€</span>
                                </template>
                            </v-text-field>
                        </v-col>

                        <!-- Uscite -->
                        <v-col cols="6">
                            <v-text-field v-model.number="localItem.uscita" label="Uscite" outlined dense type="number"
                                hide-details="auto"
                                :rules="[v => v == null || v >= 0 || 'Valore deve essere positivo']">
                                <template v-slot:prepend-inner>
                                    <v-icon small class="mt-1 mr-1" color="error">trending_down</v-icon>
                                </template>
                                <template v-slot:append>
                                    <span class="caption text--secondary mt-1">€</span>
                                </template>
                            </v-text-field>
                        </v-col>

                        <!-- Note -->
                        <v-col cols="12">
                            <v-textarea v-model="localItem.note" label="Note" outlined dense rows="2" auto-grow
                                hide-details="auto" />
                        </v-col>

                        <!-- Escludi dal calcolo -->
                        <v-col cols="12" class="pt-0 pb-2">
                            <v-checkbox v-model="localItem.escludiCalcolo" label="Escludi dal calcolo" dense
                                class="mt-0" />
                        </v-col>

                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-4 py-3">
                <v-btn text @click="handleClose">
                    <v-icon left small>close</v-icon>
                    Annulla
                </v-btn>

                <v-spacer />

                <v-btn color="primary" dark @click="handleSave" :disabled="!isFormValid || saving" :loading="saving">
                    <v-icon left small>save</v-icon>
                    Salva
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CashflowDialog",

    props: {
        value: {
            type: Boolean,
            required: true
        },
        editedItem: {
            type: Object,
            required: true
        },
        isNew: {
            type: Boolean,
            default: true
        },
        // true mentre il salvataggio è in corso: impedisce il doppio invio
        saving: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        localItem: {},
        menuOrario: false,
        tipoImportoOptions: ['Reale', 'Previsionale', 'Banca']
    }),

    computed: {
        isFormValid() {
            return (
                this.localItem.descrizione?.trim() &&
                this.localItem.data &&
                this.localItem.tipologia &&
                (this.localItem.entrata == null || this.localItem.entrata >= 0) &&
                (this.localItem.uscita == null || this.localItem.uscita >= 0)
            );
        }
    },

    watch: {
        editedItem: {
            handler(newVal) {
                this.localItem = { ...newVal };
            },
            immediate: true,
            deep: true
        }
    },

    methods: {

        normalizeTime() {
            if (this.$functions?.normalizzaOra) {
                this.localItem.orario = this.$functions.normalizzaOra(this.localItem.orario);
            }
        },

        handleSave() {
            if (this.saving) return;

            this.normalizeTime();
            if (!this.isFormValid) return;

            // Un campo importo svuotato diventa stringa vuota: lo trasformo in 0 prima dell'invio
            this.$emit('save', {
                ...this.localItem,
                entrata: Number(this.localItem.entrata) || 0,
                uscita: Number(this.localItem.uscita) || 0
            });
        },

        handleClose() {
            this.$emit('close');
        },
    }
};
</script>